import dayjs from 'dayjs'

export const dateFormat = (value: string | dayjs.Dayjs): string => {
  return dayjs(value).format('DD/MM/YYYY')
}

export const dateAtFormat = (value: string | dayjs.Dayjs): string => {
  return dayjs(value).format('DD/MM/YYYY [at] HH:mm')
}

export const dateTextFormat = (value: string | dayjs.Dayjs): string => {
  return dayjs(value).format('D MMM YYYY')
}

export const dateTextAtFormat = (value: string | dayjs.Dayjs): string => {
  return dayjs(value).format('D MMM YY [at] HH:mm')
}

export const dateTimeFormat = (value: string): string => {
  return dayjs(value).format('HH:mm')
}

export const dateYearMonthDayFormat = (value: string | dayjs.Dayjs): string => {
  return dayjs(value).format('YYYY-MM-DD')
}

export const dateTexTimeFormat = (value: string | dayjs.Dayjs): string => {
  return dayjs(value).format('D MMM YY, HH:mm')
}
